import requestService from '@/services/request.service'
import { ComboWithVoteData } from '@/types/combo'

const FIREBASE_FUNCTIONS_API = 'https://api-ovkpavkgwq-uc.a.run.app'

const fetchComboVote = async (n: number): Promise<ComboWithVoteData | { error: string }> => {
  const response = await requestService.get(`${FIREBASE_FUNCTIONS_API}/combo?n=${n}`, { credentials: 'include' })
  return response.json()
}

const submitComboVote = async (
  voteId: string,
  vote: { isEarlyGame: boolean; isEasyPrereq: boolean; isSignificantResult: boolean },
): Promise<{ message: string } | { error: string }> => {
  const response = await requestService.post(
    `${FIREBASE_FUNCTIONS_API}/voteCombo`,
    { vote, voteId },
    { credentials: 'include' },
  )
  return response.json()
}

const VoteService = {
  fetchComboVote,
  submitComboVote,
}

export default VoteService
